module.exports = __webpack_public_path__ + "static/media/steel.4ec274d2.jpg";